<template>
    <v-row justify="center">
        <v-dialog v-model="showDialog" persistent max-width="400">
            <v-card>
                <v-card-title class="headline pt-1 pr-1 custom-card-header">
                    Confirm Archive
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="toggle"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <div v-if="incompleteTasks.length !== 0">
                    <v-card-text class="pb-1">Archiving the selected route will also archive the tasks below</v-card-text>
                    <span v-for="(task, index) in incompleteTasks" v-bind:key="index">
                        <v-card-text class="red-text">{{ task.taskNumber }} --- {{ task.status }} --- {{ task.address.slice(0, -12)}}</v-card-text>
                    </span>
                </div>
                <br />
                <v-card-text class="pb-1"> Are you sure you want to archive this route?</v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="primary" class="ma-2" @click="archive">Archive</v-btn>
                    <v-btn color="primary" outlined class="ma-2" @click="toggle">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import { mapActions } from 'vuex'
    export default {
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            },
            route: {
                type: Object
            },
            incompleteTasks: {
                type: Array
            }
        },
        methods: {
            ...mapActions({
                archiveRoute: 'routes/archive',
                archiveTask: 'jobTasks/archive'
            }),
            async archive () {
                this.route.jobTasks.forEach(jt => {
                    this.archiveTask(jt.id)
                })
                await this.archiveRoute(this.route.id)
                this.toggle()
            }
        }
    }
</script>
<style scoped>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
    .red-text {
        color: red;
    }
</style>
